import { useEffect } from "react";

type Props = { children: React.ReactNode };

export const ThemeProvider = ({ children }: Props) => {
  useEffect(() => {
    document.documentElement.classList.remove("dark", "dark-admin", "dark-amba", "dark-user");
    document.documentElement.style.colorScheme = "light";
    try {
      window.localStorage.removeItem("theme");
    } catch {
      // Le mode clair reste actif si le stockage est indisponible.
    }
  }, []);

  return children;
};
